/**
 * @generated
 * This file was automatically generated and should not be manually edited.
 *
 * Auto-generated enum for: users.role
 *
 * To regenerate: npm run db:codegen
 * Any manual changes will be overwritten on next generation.
 */

/* eslint-disable */
// @ts-nocheck

/**
 * UserRole enum representing allowed values for users.role
 */
export enum UserRole {
  /** Student */
  STUDENT = 'student',
  /** Mentor */
  MENTOR = 'mentor',
  /** Admin */
  ADMIN = 'admin',
}
